import styled from 'styled-components';

export const ContainerInputSearch = styled.div`
  width: calc(231px - 27px);
  height: 32px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  padding: 0 16px;

  border: 1px solid var(--color-blue-cyan);
  background: var(--color-white);
  border-radius: 1000px;

  #site-search {
    border: none;
    margin-left: 3px;
    height: 100%;
  }
  #site-search:focus {
    outline: none;
  }
`;
